module.exports = __webpack_public_path__ + "img/pergamin_logo_color2.3972f983.svg";